import service from './axios';
export const getBalanceRecords = (params = {}) => service.get('/manage/balance-records', { params });
export const adjustBalance = (d) => service.post('/manage/balance-records/adjust', d);
export const getCheckinRecords = (params = {}) => service.get('/manage/checkin-records', { params });
export const getVerificationRecords = (params = {}) => service.get('/manage/verification-records', { params });
export const getMembershipSettings = () => service.get('/manage/membership-settings');
export const updateMembershipSettings = (d) => service.put('/manage/membership-settings', d);
export const getMemberLevels = (params = {}) => service.get('/manage/member-levels', { params });
export const createMemberLevel = (d) => service.post('/manage/member-levels', d);
export const updateMemberLevel = (id, d) => service.put(`/manage/member-levels/${id}`, d);
export const deleteMemberLevel = (id) => service.delete(`/manage/member-levels/${id}`);

// ===== 充值金额管理 =====
export const getRechargeAmounts = (params = {}) => service.get('/manage/recharge-amounts', { params });
export const createRechargeAmount = (d) => service.post('/manage/recharge-amounts', d);
export const updateRechargeAmount = (id, d) => service.put(`/manage/recharge-amounts/${id}`, d);
export const toggleRechargeAmount = (id) => service.put(`/manage/recharge-amounts/${id}/toggle`);
export const deleteRechargeAmount = (id) => service.delete(`/manage/recharge-amounts/${id}`);
